import { ArrayNotEmpty, IsArray, IsNotEmpty, IsOptional, IsString, IsUUID } from 'class-validator';

export class CreateRegionDto {
  @IsString()
  @IsNotEmpty()
  name: string;

  @ArrayNotEmpty({ message: 'Countries are required' })
  @IsArray()
  @IsUUID('4', { each: true })
  countryIds: string[];

  @IsOptional()
  @IsArray()
  @IsUUID('4', { each: true })
  subdivisionIds?: string[];
}
